export const subscriptiontypeConstants = {
    GETALL_REQUEST: 'SUBSCRIPTIONTYPE_GETALL_REQUEST',
    GETALL_SUCCESS: 'SUBSCRIPTIONTYPE_GETALL_SUCCESS',
    GETALL_FAILURE: 'SUBSCRIPTIONTYPE_GETALL_FAILURE',

    DELETE_REQUEST: 'SUBSCRIPTIONTYPE_DELETE_REQUEST',
    DELETE_SUCCESS: 'SUBSCRIPTIONTYPE_DELETE_SUCCESS',
    DELETE_FAILURE: 'SUBSCRIPTIONTYPE_DELETE_FAILURE'
};
